/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { plpSelectSX } from '@/components/content/CatalogEntryList/styles/container';
import { SORT_OPTIONS } from '@/data/constants/HelloretailSearch';
import { useHelloRetailSearch } from '@/data/Content/HelloRetailSearch';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { FC, useContext } from 'react';


export const HelloretailProductsSort: FC = () => {

	const listSettingsNLS = useLocalization('CommerceEnvironment').listSettings;
	const ProductGrid = useLocalization('ProductGrid').Labels;
	const {
		sortyBy,
		setSortBy
	} = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;
	return (
		<FormControl variant="outlined">
			<InputLabel id="overlay_productGrid_sort_label" sx={{display:'none'}}>{`${ProductGrid.sortBy.t()}:`}</InputLabel>
			<Select
				labelId="overlay_productGrid_sort_label"
				data-testid="list-sort-option"
				id="productGrid_select"
				value={sortyBy}
				onChange={(event)=>setSortBy(event.target.value)}
				fullWidth
				sx={plpSelectSX}
				size='small'
				MenuProps={{
					style: {zIndex: 10001},
				}}
			>
				{SORT_OPTIONS?.map((option) => (
					<MenuItem
						value={option.value}
						key={option.value}
						id={`productGrid_option_${option.value}`}
						data-testid={`productGrid_option_${option.value}`}
					>
						{listSettingsNLS[option.translationKey as keyof typeof listSettingsNLS].t()}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};